import * as React from "react";
import {useBrandQuery} from "../../../hooks/useBrandQuery";

export const BrandLink = () => {
    const {model: {brand: {name, link, image}}} = useBrandQuery();

    if (!name || !link) return <></>;

    return (
        <span> Part of the{" "}
            <a href={link}  tabIndex={0} role="link" aria-label={`View the ${name} Collection`}>
                {name} Collection
             </a>
        </span>
    );
};